const f = {
  color: {
    wrapper: {
      border: "#abb9c7ff",
      text: "#abb9c7ff"
    },
    icon: "#7e8e9eff",
    background: "#ffffffff",
    input: {
      text: "#314351ff",
      placeholder: "#556575ff"
    },
    listItem: {
      text: "#314351ff",
      title: "#131b24ff",
      subtitle: "#556575ff",
      disabled: {
        text: "#7e8e9eff"
      },
      action: {
        text: "#304ddbff"
      },
      selected: {
        text: "#ffffffff",
        title: "#ffffffff",
        subtitle: "#d1e8ffff",
        background: "#304ddbff"
      },
      icon: {
        default: "#314351ff",
        hover: "#253642ff"
      },
      highlighted: {
        text: "#131b24ff",
        subtitle: "#405261ff",
        background: "#f1f3f5ff"
      },
      multiple: {
        highlighted: {
          text: "#253642ff"
        }
      }
    },
    selectedBadge: {
      border: "#abb9c7ff",
      hover: "#304ddbff",
      disabled: {
        border: "#abb9c7ff",
        shadow: "#c8d3deff",
        background: "#f9fafaff"
      }
    },
    divider: "#f1f3f5ff",
    groupLabel: "#556575ff",
    togglers: {
      navLink: {
        text: "#9ecbffff",
        background: "#1c2674ff",
        attention: "#ff5caaff"
      },
      splitButton: {
        shadowDisabled: "#7e8e9eff",
        yellow: {
          text: {
            default: "#7a4518ff",
            hover: "#573b23ff"
          },
          bg: {
            default: "#fff6e5ff",
            hover: "#ffeeccff"
          },
          border: {
            default: "#fabf5aff",
            hover: "#e09c24ff"
          },
          disabled: {
            bg: "#f9fafaff",
            text: "#abb9c7ff"
          }
        }
      },
      select: {
        shadow: "#abb9c7ff",
        text: "#405261ff",
        shadowError: "#e54a32ff",
        disabled: "#7e8e9eff"
      },
      selectArrow: {
        border: "#314351ff"
      }
    }
  },
  radius: {
    menu: "12px"
  },
  shadow: {
    menu: "0px 0px 0px 1px rgba(49, 67, 81, 0.06), 0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 4px 32px 0px rgba(0, 0, 0, 0.06)"
  }
};
export {
  f as dropList
};
